import { useContext, useState } from 'react';
import { ListSubheader, List, ListItemButton, ListItem, ListItemIcon, ListItemText, Collapse, Stack, Button } from '@mui/material';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import EmailIcon from '@mui/icons-material/Email';
import CallIcon from '@mui/icons-material/Call';
import HttpsIcon from '@mui/icons-material/Https';

import '../../styles/formStyles.css';
import { BasicForm, PassForm } from './components/Forms';
import { AuthContext } from '../../auth/authContext';
import { types } from '../../types/types';

export const ProfileEditScreen = () => {

  const [openMail, setOpenMail] = useState(false);
  const [openTel, setOpenTel] = useState(false);
  const [openPassword, setOpenPassword] = useState(false);
  const { dispatch } = useContext(AuthContext);


  const handleClick = (type) => {
    if (type === 'email') {
      setOpenMail(!openMail);
    } else if (type === 'tel') {
      setOpenTel(!openTel);
    } else if (type === 'pass') {
      setOpenPassword(!openPassword);
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem('authToken');
    localStorage.removeItem('authToken');
    dispatch({
      type: types.logout,
      payload: {
        logged: false,
        email: ''
      }
    })
  }


  return (
    <Stack width='100%' mt='2rem' alignItems='center' >
      <Stack spacing={5} width='95%' >
        <h1 >Edición de perfil</h1>
        <List
          sx={{ width: '100%', minWidth: '500px', bgcolor: 'background.paper' }}
          component="nav"
          aria-labelledby="nested-list-subheader"
          className='form_container'
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              Modificar Perfil
            </ListSubheader>
          }
        >

          <ListItemButton onClick={() => handleClick('email')} >
            <ListItemIcon>
              <EmailIcon />
            </ListItemIcon>
            <ListItemText primary="Editar email" />
            {openMail ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>

          <Collapse in={openMail} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem sx={{ pl: 4 }} >
                <BasicForm label='Email' buttonLabel='Guardar nuevo email' reset={setOpenMail}/>
              </ListItem>
            </List>
          </Collapse>
          <ListItemButton onClick={() => handleClick('tel')}>
            <ListItemIcon>
              <CallIcon />
            </ListItemIcon>
            <ListItemText primary="Editar Teléfono" />
            {openTel ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={openTel} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem sx={{ pl: 4 }}>
                <BasicForm label='Teléfono' buttonLabel='Guardar nuevo teléfono' reset={setOpenTel}/>
              </ListItem>
            </List>
          </Collapse>

          <ListItemButton onClick={() => handleClick('pass')}>
            <ListItemIcon>
              <HttpsIcon />
            </ListItemIcon>
            <ListItemText primary="Cambiar contraseña" />
            {openPassword ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={openPassword} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem sx={{ pl: 4 }}>
                <PassForm reset={setOpenPassword}/>
              </ListItem>
            </List>
          </Collapse>
        </List>
        <Button variant='outlined' sx={{ width: '160px' }} onClick={handleLogout} >Cerrar sesión</Button>
      </Stack>
    </Stack>
  )
}
